export default "__VITE_ASSET__BSWLa8m___"